import React, { useState } from 'react';
import { CheckCircle, AlertCircle, Loader } from 'lucide-react';
import asaasService from '../../services/asaasService';

const TesteAsaas: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState<any>(null);
  const [erro, setErro] = useState<string>('');

  const testarConexao = async () => {
    setLoading(true);
    setErro('');
    setResultado(null);

    try {
      console.log('🔍 [TESTE] Testando conexão com Asaas...');
      
      // Testar configuração
      const config = asaasService.getConfig();
      console.log('🔍 [TESTE] Configuração:', config);

      // Testar criação de cliente
      const clienteTeste = {
        name: 'Cliente Teste',
        email: 'teste@exemplo.com',
        cpfCnpj: '65091828079',
        phone: '11987779999',
        postalCode: '01234567',
        address: 'Rua Teste',
        addressNumber: '123',
        complement: '',
        province: 'Centro',
        city: 'São Paulo',
        state: 'SP'
      };

      console.log('🔍 [TESTE] Criando cliente de teste...');
      const cliente = await asaasService.criarCliente(clienteTeste);
      
      setResultado({
        sucesso: true,
        config,
        cliente,
        message: 'Conexão com Asaas funcionando perfeitamente!'
      });

    } catch (error) {
      console.error('❌ [TESTE] Erro:', error);
      setErro(error instanceof Error ? error.message : 'Erro desconhecido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Teste de Integração Asaas
        </h2>
        <p className="text-gray-600">
          Verifique se a conexão com o Asaas está funcionando
        </p>
      </div>

      {/* Botão de teste */}
      <div className="text-center mb-6">
        <button
          onClick={testarConexao}
          disabled={loading}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center mx-auto"
        >
          {loading ? (
            <>
              <Loader className="w-4 h-4 mr-2 animate-spin" />
              Testando...
            </>
          ) : (
            'Testar Conexão Asaas'
          )}
        </button>
      </div>

      {/* Resultado do teste */}
      {resultado && (
        <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
          <div className="flex items-center mb-4">
            <CheckCircle className="w-6 h-6 text-green-500 mr-2" />
            <h3 className="text-lg font-semibold text-green-900">
              Teste Bem-sucedido!
            </h3>
          </div>
          
          <p className="text-green-800 mb-4">
            {resultado.message}
          </p>

          <div className="bg-white rounded-lg p-4 mb-4">
            <h4 className="font-semibold text-gray-900 mb-2">Configuração:</h4>
            <div className="text-sm text-gray-700 space-y-1">
              <p><strong>Environment:</strong> {resultado.config.environment}</p>
              <p><strong>Base URL:</strong> {resultado.config.baseURL}</p>
              <p><strong>API Key:</strong> {resultado.config.apiKey ? '✅ Configurada' : '❌ Não configurada'}</p>
            </div>
          </div>

          <div className="bg-white rounded-lg p-4">
            <h4 className="font-semibold text-gray-900 mb-2">Cliente Criado:</h4>
            <div className="text-sm text-gray-700 space-y-1">
              <p><strong>ID:</strong> {resultado.cliente.id}</p>
              <p><strong>Nome:</strong> {resultado.cliente.name}</p>
              <p><strong>Email:</strong> {resultado.cliente.email}</p>
            </div>
          </div>
        </div>
      )}

      {/* Erro */}
      {erro && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <div className="flex items-center mb-4">
            <AlertCircle className="w-6 h-6 text-red-500 mr-2" />
            <h3 className="text-lg font-semibold text-red-900">
              Erro no Teste
            </h3>
          </div>
          
          <p className="text-red-800 mb-4">
            {erro}
          </p>

          <div className="bg-white rounded-lg p-4">
            <h4 className="font-semibold text-gray-900 mb-2">Possíveis Soluções:</h4>
            <ul className="text-sm text-gray-700 space-y-1">
              <li>• Verifique se o token está correto no arquivo .env</li>
              <li>• Certifique-se de que REACT_APP_ASAAS_API_KEY está definida</li>
              <li>• Reinicie o servidor de desenvolvimento</li>
              <li>• Verifique se está usando o token do sandbox</li>
            </ul>
          </div>
        </div>
      )}

      {/* Instruções */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-blue-900 mb-3">
          Como Configurar:
        </h3>
        <ol className="text-sm text-blue-800 space-y-2">
          <li>1. Crie um arquivo <code className="bg-blue-100 px-1 rounded">.env</code> na raiz do projeto</li>
          <li>2. Adicione: <code className="bg-blue-100 px-1 rounded">REACT_APP_ASAAS_API_KEY=seu_token_aqui</code></li>
          <li>3. Reinicie o servidor: <code className="bg-blue-100 px-1 rounded">npm start</code></li>
          <li>4. Execute este teste para verificar</li>
        </ol>
      </div>
    </div>
  );
};

export default TesteAsaas;
